'use strict';

class HabilitarCorteExcepcional {
  constructor ($uibModalInstance, $location, data, $log, DataService, Message, $state) {
    'ngInject';
    this.mesActual = data;
    this.$location = $location;
    this.$uibModalInstance = $uibModalInstance;
    this.$log = $log;
    this.DataService = DataService;
    this.Message = Message;
    this.$state = $state;
    this.confirmado = false;
  }

  $onInit () {
    this.tituloPagina = 'Confirme habilitación del corte excepcional';
    this.gestion = (new Date()).getFullYear();
  }
  cancel () {
    this.$uibModalInstance.dismiss('cancel');
  }

  habilitarCorteExcepcional () {
    this.DataService.get(`centralizador/soporte/corte-excepcional`)
      .then(response => {
        if (response && response.finalizado) {
          this.$location.path(`/operaciones_mensual/operaciones/${this.gestion}`);
          this.$uibModalInstance.dismiss('cancel');
          this.$state.reload();
        }
      });
  }
}
export default HabilitarCorteExcepcional;



// WEBPACK FOOTER //
// ./src/app/components/operaciones/corteMensual/habilitarCorteExcepcional.controller.js